// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@keyframes BottomSheet-module_getOutAnimation___cjWJ {
    0% {
        transform: translateY(0);
    }
    100% {
        transform: translateY(90vh);
    }
}

.BottomSheet-module_overlay__EcXjp {
    align-items: center;
    background: rgba(0, 0, 0, 0.48);
    bottom: 0;
    display: block;
    justify-content: center;
    left: 0;
    position: fixed;
    right: 0;
    top: 0;
    z-index: 10000;
}

.BottomSheet-module_popupOuter__eosJh {
    align-items: flex-end;
    display: flex;
    justify-content: center;
    height: 100%;
    padding: 0 16px;
}

.BottomSheet-module_popupBox__bOQxC {
    animation-duration: 0.6s;
    animation-delay: 0.1s;
    animation-timing-function: cubic-bezier(0.68, -0.55, 0.265, 1.55);
    animation-iteration-count: 1;
    overflow: hidden;
    bottom: 24px;
    max-width: 568px;
    position: relative;
    width: 100%;
    display: flex;
    flex-direction: column;
}

.BottomSheet-module_popupBoxAnimated__waLlD {
    animation-name: BottomSheet-module_getOutAnimation___cjWJ;
}

.BottomSheet-module_popupBoxContentWrapper__Ed5JJ {
    background: var(--color-white);
    border-radius: 12px;
    max-height: 100%;
    overflow: hidden;
    display: flex;
    flex-direction: column;
}

.BottomSheet-module_popupBoxContent__LbAip {
    max-height: 100%;
    overflow-y: auto;
}

@media screen and (min-width: 708px) {
    .BottomSheet-module_popupOuter__eosJh {
        align-items: center;
    }

    .BottomSheet-module_popupBox__bOQxC {
        bottom: auto;
        border-radius: 16px;
        max-height: calc(100vh - 96px);
    }

    .BottomSheet-module_popupBoxContentWrapper__Ed5JJ {
        padding: 0;
        border-radius: 16px;
    }
}
`, "",{"version":3,"sources":["webpack://./../../libs/core/src/components/Popup/BottomSheet.module.css"],"names":[],"mappings":"AAAA;IACI;QACI,wBAAwB;IAC5B;IACA;QACI,2BAA2B;IAC/B;AACJ;;AAEA;IACI,mBAAmB;IACnB,+BAA+B;IAC/B,SAAS;IACT,cAAc;IACd,uBAAuB;IACvB,OAAO;IACP,eAAe;IACf,QAAQ;IACR,MAAM;IACN,cAAc;AAClB;;AAEA;IACI,qBAAqB;IACrB,aAAa;IACb,uBAAuB;IACvB,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,wBAAwB;IACxB,qBAAqB;IACrB,iEAAiE;IACjE,4BAA4B;IAC5B,gBAAgB;IAChB,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;IAClB,WAAW;IACX,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,yDAA+B;AACnC;;AAEA;IACI,8BAA8B;IAC9B,mBAAmB;IACnB,gBAAgB;IAChB,gBAAgB;IAChB,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI;QACI,mBAAmB;IACvB;;IAEA;QACI,YAAY;QACZ,mBAAmB;QACnB,8BAA8B;IAClC;;IAEA;QACI,UAAU;QACV,mBAAmB;IACvB;AACJ","sourcesContent":["@keyframes getOutAnimation {\n    0% {\n        transform: translateY(0);\n    }\n    100% {\n        transform: translateY(90vh);\n    }\n}\n\n.overlay {\n    align-items: center;\n    background: rgba(0, 0, 0, 0.48);\n    bottom: 0;\n    display: block;\n    justify-content: center;\n    left: 0;\n    position: fixed;\n    right: 0;\n    top: 0;\n    z-index: 10000;\n}\n\n.popupOuter {\n    align-items: flex-end;\n    display: flex;\n    justify-content: center;\n    height: 100%;\n    padding: 0 16px;\n}\n\n.popupBox {\n    animation-duration: 0.6s;\n    animation-delay: 0.1s;\n    animation-timing-function: cubic-bezier(0.68, -0.55, 0.265, 1.55);\n    animation-iteration-count: 1;\n    overflow: hidden;\n    bottom: 24px;\n    max-width: 568px;\n    position: relative;\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n}\n\n.popupBoxAnimated {\n    animation-name: getOutAnimation;\n}\n\n.popupBoxContentWrapper {\n    background: var(--color-white);\n    border-radius: 12px;\n    max-height: 100%;\n    overflow: hidden;\n    display: flex;\n    flex-direction: column;\n}\n\n.popupBoxContent {\n    max-height: 100%;\n    overflow-y: auto;\n}\n\n@media screen and (min-width: 708px) {\n    .popupOuter {\n        align-items: center;\n    }\n\n    .popupBox {\n        bottom: auto;\n        border-radius: 16px;\n        max-height: calc(100vh - 96px);\n    }\n\n    .popupBoxContentWrapper {\n        padding: 0;\n        border-radius: 16px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"overlay": `BottomSheet-module_overlay__EcXjp`,
	"popupOuter": `BottomSheet-module_popupOuter__eosJh`,
	"popupBox": `BottomSheet-module_popupBox__bOQxC`,
	"popupBoxAnimated": `BottomSheet-module_popupBoxAnimated__waLlD`,
	"getOutAnimation": `BottomSheet-module_getOutAnimation___cjWJ`,
	"popupBoxContentWrapper": `BottomSheet-module_popupBoxContentWrapper__Ed5JJ`,
	"popupBoxContent": `BottomSheet-module_popupBoxContent__LbAip`
};
export default ___CSS_LOADER_EXPORT___;
